export default "__VITE_ASSET__Bp2hWoBp__"